import { FC } from 'react';

import { useLocalStorage } from '@dbt-labs/metadata-shared';
import { NotificationBanner, NotificationBannerProps } from '@dbt-labs/sourdough';

interface DismissableNotificationBannerProps extends NotificationBannerProps {
  localStorageKey: string;
}

export const DismissableNotificationBanner: FC<DismissableNotificationBannerProps> = ({
  localStorageKey,
  ...props
}) => {
  const [isDismissed, setIsDismissed] = useLocalStorage(
    localStorageKey,
    (value: any) => (typeof value === 'boolean' ? value : false),
    false,
  );

  if (isDismissed) return null;
  return (
    <NotificationBanner
      {...props}
      onCloseClick={() => {
        setIsDismissed(true);
      }}
    />
  );
};
